import http from '../util/axios'
import config from '../../config/endpoints.js'
import moment from 'moment'
import { call } from 'file-loader';
//  Default BASE API URL
const API_URL = config.chs_url;
const CMS_URL = config.cms_url;
const CAPTAIN_URL=config.captain_url;
const STATIC_URL = config.oh_url;
const PH_URL = config.ph_url;
const COM_URL= config.com_url
const PHARMACY_URL=config.pharmacy_url
const FD_URL = config.fd_url
const CAREGIVER_URL = config.caregiver_url
const NOTIFICATION = config.notification
const PRE_EMPLOYEMENT = config.pre_employement_url
const AUTH_URL = config.auth_url
const WASEEL_URL = config.waseel_url
const CORPORATE_URL = config.corporate_url
const BLOOD_DONATION_URL = config.blood_donation
const PHYSIO_SESSION_URL = config.physio_session
const NURSE_SUBSCRIPTION_URL = config.nurse_subscription_url
const SOCKET_URL = config.socketHub
const USER_SERVICES_URL = config.user_services_url
const AL_DAWA_URL = config.al_dawa_url
const TELE_MEDICINE_URL = config.tele_medicine_services_url
const HOME_VIST_DOCTOR_URL = config.home_visit_doctor_url
const ADMIN_SERVICE_URL = config.admin_serv__url
const APPOINTMENT_SERVICE_URL = config.aps_url

/**
 * @description Api Service Module
 * @author Fahid Mohamamd
 * @date 21-12-2018
 */
const API = {
   getStaticData: function (param, uid, stid, eid, callback) {
      let requestData = { "mtype": param }
      if (uid) { requestData.utid = uid }
      if (requestData.utid=='1') { requestData.stid = stid }
      if (eid) { requestData.eid = eid }
      http.post(API_URL + '/general/getStaticData', requestData).then(response => {
         const { status, data } = response
         let responseObject = { status: status, data: null }
         if (status === 1000) {
            if (typeof data === 'object') {
               responseObject.data = data
            }
         }
         return callback(responseObject)
      })

   },

   addCaptains:function (param,callback) {
      http.post(CAPTAIN_URL+'v1/addCaptain',param).then(response => {
         return callback(response)
      })
   },
   captainStatusUpdate:function (param, callback) {
      http.post(CAPTAIN_URL + 'v1/status', param).then(response => {
         return callback(response)
      })
   },
   getCityData: function (param, callback) {
      http.post(API_URL + '/general/getStaticData', param).then(response => {
         const { status, data } = response
         let responseObject = { status: status, data: null }
         if (status === 1000) {
            if (typeof data === 'object') {
               responseObject.data = data
            }
         }
         return callback(responseObject)
      })

   },
   getDep: function (callback) {
      http.post(API_URL + '/general/MDepts').then(response => {
         return callback(response)
      })

   },
   getHospitals: function (param, callback) {
      http.post(API_URL + '/hospital/list', param).then(response => {
         return callback(response)
      })
   },
   getCaptainList: function (param, callback) {
      http.post(CAPTAIN_URL + 'v1/fetch-all', param).then(response => {
         return callback(response)
      })
   },
   getCaptainDetails: function (param, callback) {
      http.get(CAPTAIN_URL + 'v1/captainInfo?'+'cap_id='+param.cap_id).then(response => {
         return callback(response)
      })
   },
   getCaptainMap: function (callback) {
      http.post(API_URL + '/hospital/select').then(response => {
         return callback(response)
      })
   },
   getHeadHospitals: function (callback) {
      http.get(API_URL + '/hospital/getHeadHospitals').then(response => {
         return callback(response)
      })
   },
   editCaptainDet: function (param, callback) {
      http.post(CAPTAIN_URL + 'v1/captainDetails',param).then(response => {
         return callback(response)
      })
   },
   updateCaptainDet: function (param, callback) {
      http.post(CAPTAIN_URL + 'v1/update',param).then(response => {
         return callback(response)
      })
   },
   addHospital: function (param, callback) {
      http.post(API_URL + '/hospital/add', param).then(response => {
         return callback(response)
      })
   },
   getHospitalEmployees: function (param, callback) {
      http.post(API_URL + '/hospital/employeelist', param).then(response => {
         return callback(response)
      })
   },
   getHospitalsAndUsers: function (callback) {
      http.post(API_URL + '/hospital/select').then(response => {
         return callback(response)
      })
   },
   saveEmployeeData: function (requestData, callback) {
      http.post(API_URL + '/hospital/addEmployee ', requestData).then(response => {
         return callback(response)
      })
   },
   updateEmployee: function (requestData, callback) {
      http.post(API_URL + '/hospital/updateEmployee', requestData).then(response => {
         return callback(response)
      })
   },
   updatehsppwd: function (requestData, callback) {
      http.post(API_URL + '/hospital/updatePassword', requestData).then(response => {
         return callback(response)
      })
   },
   updateemppwd: function (requestData, callback) {
      http.post(API_URL + '/hospital/updateEmpPassword', requestData).then(response => {
         return callback(response)
      })
   },
   getHospitalsById: function (param, callback) {
      http.post(API_URL + '/hospital/getHospital', param).then(response => {

         return callback(response)
      })
   },
   getDoctorById: function (param, callback) {
      http.post(API_URL + '/doctor/id', param).then(response => {
         return callback(response)
      })
   },
   getEmployeeById: function (param, callback) {
      http.post(API_URL + '/hospital/getEmployee ', param).then(response => {
         const { status, data } = response
         let responseObject = { status: status, data: null }
         if (status === 1000 && _.isObject(data)) {
            let commonData = data.commonData ? data.commonData : data,
               empSpecData = data.empSpecificData ? data.empSpecificData : {};
            /* if (!empSpecData['exp']) {
               empSpecData['exp'] = { 'val': 0, 'dura_type': "Years" }
            } else {
               empSpecData['exp'] = { 'val': empSpecData['exp'], 'dura_type': "Years" }
            } */
            //  Need to clean the response
            _.assign(commonData, empSpecData)
            // Bind final object
            responseObject.data = commonData
         }
         return callback(responseObject)
      })
   },
   getSchedules: function (requestData, callback) {
      http.post(API_URL + '/schedule/get/docphy', requestData).then(response => {
         return callback(response)
      })
   },
   addSchedule: function (data, uid, utid, duration, callback) {
      let requestData = {
         "uid": uid,
         "utid": utid,
         "slots": data
      }
      if(duration) requestData['duration'] = duration
      http.post(API_URL + '/schedule/add/doc', requestData).then(response => {
         return callback(response)
      })
   },
   getDoctors: function (data, callback) {
      http.post(API_URL + '/doctor/list', data).then(response => {
         return callback(response)
      })
   },
   getFormRequests: function (data, callback) {
      http.post(STATIC_URL + '/web/formRequest/list', data).then(response => {
         return callback(response)
      })
   },
   addOrEditDoctor: function (data, callback) {
      http.post(API_URL + '/doctor/edit', data).then(response => {
         return callback(response)
      })
   },
   getSanarDoctorSchedules: function (data, callback) {
      http.post(API_URL + '/doctor/id', data).then(response => {
         return callback(response)
      })
   },
   getDoctorsVerify: function (data, callback) {
      http.post(API_URL + '/doctor/verlist', data).then(response => {
         return callback(response)
      })
   },
   publishDoctor: function (data, callback) {
      http.post(API_URL + '/doctor/ver_act', data).then(response => {
         return callback(response)
      })
   },
   tamaraList: function (param, callback) {
      http.post(API_URL + '/tamara/list', param).then(response => {
         return callback(response)
      })
   },
   familyDoctorReports: function (param, callback) {
      http.post(API_URL + '/reports/familywallet/list', param).then(response => {
         return callback(response)
      })
   },
   updateHospital: function (data, callback) {
      http.post(API_URL + '/hospital/update', data).then(response => {
         return callback(response)
      })
   },
   getAppUsers: function (param, callback) {
      http.post(API_URL + '/patients/userlist', param).then(response => {
         return callback(response)
      })
   },
   getAppointmentSettings: function (param, callback) {
      http.post(API_URL + '/settings/getHospSettings', param).then(response => {
         return callback(response)
      })
   },
   getdefaultDuration: function (param, callback) {
      http.post(STATIC_URL + '/schedule/getSlotsDuration', param).then(response => {
         return callback(response)
      })
   },
   getnlSchedules: function (requestData, callback) {
      http.post(API_URL + '/schedule/get/nlt', requestData).then(response => {
         return callback(response)
      })
   },
   addnlSchedule: function (param, data, hspid, vld_frm, currentdate, callback) {
      let requestData = {
         "params": {
            "utid": param,
            "slots": data,
            "eid": hspid,
            'vld_frm':vld_frm || currentdate
         }
      }
      http.post(API_URL + '/schedule/add/nlt', requestData).then(response => {
         return callback(response)
      })
   },
   saveAppointments: function (param, callback) {
      let requestData = {
         "params": {
            // "auto_conf_apt": param.confirm_online,
            "eid": param.eid,
            "srvc": {
               "1": {
                  "ST0": {
                     "dur": param.defualt_home_dur,
                     "fee": {
                        "val": param.defualt_home_fee,
                        "curr": "SAR"
                     },
                     "buffer_time":param.default_home_buffer
                  },
                  "ST1": {
                     "dur": param.defualt_video_dur,
                     "fee": {
                        "val": param.defualt_video_fee,
                        "curr": "SAR"
                     },
                     "buffer_time":param.default_video_buffer
                  },
                  "ST2": {
                     "dur": param.defualt_chat_dur,
                     "fee": {
                        "val": param.defualt_chat_fee,
                        "curr": "SAR"
                     },
                     "buffer_time":param.default_chat_buffer
                  },
               },
               "2": {
                  "ST0": {
                     "dur": param.p_defualt_home_dur,
                     "fee": {
                        "val": param.p_defualt_home_fee,
                        "curr": "SAR"
                     },
                     "buffer_time":param.p_defualt_buffer_time
                  },

               },
               "3": {
                  "ST0": {
                     "dur": param.nurse_homr_dur,
                     "fee": {
                        "val": param.nurse_hm_fee,
                        "curr": "SAR"
                     },
                     "min_fee": param.min_nursefee,
                     "buffer_time":param.nurse_defualt_buffer_time
                  },
                  "ST031": {
                     // "dur": param.radiology_homr_dur,
                     // "fee": {
                     //    "val": param.radiology_hm_fee,
                     //    "curr": "SAR"
                     // },
                     // "min_fee": param.min_radiologyfee,
                     "buffer_time":param.radiology_defualt_buffer_time
                  },
                  "ST032": {
                     // "dur": param.vitamin_homr_dur,
                     // "fee": {
                     //    "val": param.vitamin_hm_fee,
                     //    "curr": "SAR"
                     // },
                     // "min_fee": param.min_vitaminfee,
                     "buffer_time":param.vitamin_defualt_buffer_time
                  },
                  "ST033": {
                     // "dur": param.vacc_homr_dur,
                     // "fee": {
                     //    "val": param.vacc_hm_fee,
                     //    "curr": "SAR"
                     // },
                     // "min_fee": param.min_vaccfee,
                     "buffer_time":param.vacc_defualt_buffer_time
                  },
                  "ST034": {
                     // "dur": param.hemo_homr_dur,
                     // "fee": {
                     //    "val": param.hemo_hm_fee,
                     //    "curr": "SAR"
                     // },
                     // "min_fee": param.min_hemofee,
                     "buffer_time":param.hemo_defualt_buffer_time
                  },
                  "ST035": {
                    // "dur": param.hemo_homr_dur,
                    // "fee": {
                    //    "val": param.hemo_hm_fee,
                    //    "curr": "SAR"
                    // },
                    // "min_fee": param.min_hemofee,
                    "buffer_time":param.Caregiver_defualt_buffer_time
                 },
                 "ST036": {
                  // "dur": param.hemo_homr_dur,
                  // "fee": {
                  //    "val": param.hemo_hm_fee,
                  //    "curr": "SAR"
                  // },
                  // "min_fee": param.min_hemofee,
                  "buffer_time":param.covid_vaccine_defualt_buffer_time
               },
               "ST037": {
                // "dur": param.hemo_homr_dur,
                // "fee": {
                //    "val": param.hemo_hm_fee,
                //    "curr": "SAR"
                // },
                // "min_fee": param.min_hemofee,
                "buffer_time":param.season_vaccine_defualt_buffer_time
             },
               "ST0310": {
                  // "dur": param.hemo_homr_dur,
                  // "fee": {
                  //    "val": param.hemo_hm_fee,
                  //    "curr": "SAR"
                  // },
                  // "min_fee": param.min_hemofee,
                  "buffer_time":param.immunization_defualt_buffer_time
               },

               },
               "4": {
                  "ST0": {
                     "dur": param.lab_homr_dur,
                     "fee": {
                        "val": param.lab_hm_fee,
                        "curr": "SAR"
                     },
                     "min_fee": param.min_labfee,
                     "buffer_time":param.lab_defualt_buffer_time
                  },
                  "ST041": {
                     // "dur": param.covid_homr_dur,
                     // "fee": {
                     //    "val": param.covid_hm_fee,
                     //    "curr": "SAR"
                     // },
                     // "min_fee": param.min_covidfee,
                     "buffer_time":param.covid_defualt_buffer_time
                  },

               }
            }
         }
      }
      http.post(API_URL + '/settings/addHospSettings', requestData).then(response => {
         return callback(response)
      })
   },
   dashboard: function (data, callback) {
      http.post(API_URL + '/dashboard', data).then(response => {
         return callback(response)
      })
   },
   dashboardnew: function (data, callback) {
      http.post(API_URL + '/dashboard/v1', data).then(response => {
         return callback(response)
      })
   },
   dashboardNewv1: function (data, callback) {
      http.post(API_URL + '/dashboardV3/v1', data).then(response => {
         return callback(response)
      })
   },
   dashboardServiceGraph: function (data, callback) {
      http.post(API_URL + '/dashboard/servicegraph', data).then(response => {
         return callback(response)
      })
   },
   dashboardConfirmedGraph: function (data, callback) {
      http.post(API_URL + '/dashboard/confirmedGraph', data).then(response => {
         return callback(response)
      })
   },
   newDashboardConfirmedGraph: function (data, callback) {
      http.post(API_URL + '/dashboardV3/confirmedGraph', data).then(response => {
         return callback(response)
      })
   },
   getDashboardCity: function (callback) {
    http.get(API_URL + '/dashboard/getCityData').then(response => {
       return callback(response)
    })
    },
    dashboardHospitalData: function (data, callback) {
      http.post(API_URL + '/dashboard/hospitalData', data).then(response => {
         return callback(response)
      })
   },
   updateStatus: function (param, callback) {
      http.post(API_URL + '/patients/update', param).then(response => {
         return callback(response)
      })
   },
   generalupdateStatus: function (param, callback) {
      http.post(API_URL + '/general/updateStatus', param).then(response => {
         return callback(response)
      })
   },
   addAccounts: function (param, callback) {
      http.post(API_URL + '/accounts/addAccounts', param).then(response => {
         return callback(response)
      })
   },
   addCommission: function (param, callback) {
      http.post(API_URL + '/accounts/addCommission', param).then(response => {
         return callback(response)
      })
   },
   getSanarDoctors: function (callback) {
      http.post(API_URL + '/accounts/sanarDocList').then(response => {
         return callback(response)
      })
   },
   getAccounts: function (param, callback) {
      http.post(API_URL + '/accounts/getAccounts', param).then(response => {
         return callback(response)
      })
   },
   getCommisions: function (param, callback) {
      http.post(API_URL + '/accounts/getCommission', param).then(response => {
         return callback(response)
      })
   },
   getMangersAndHospitals: function (callback) {
      http.post(API_URL + '/settings/select').then(response => {
         return callback(response)
      })
   },
   addManagerSettings: function (params, callback) {
      http.post(API_URL + '/settings/addSettings', params).then(response => {
         return callback(response)
      })
   },
   addSettlements: function (params, callback) {
      http.post(API_URL + '/settings/addSettlements', params).then(response => {
         return callback(response)
      })
   },
   getSettlements: function (callback) {
      http.post(API_URL + '/settings/getSettlements').then(response => {
         return callback(response)
      })
   },
   getSettingsDetails: function (params, callback) {
      http.post(API_URL + '/settings/settingsDetails', params).then(response => {
         return callback(response)
      })
   },
   forgotpwd: function (param, callback) {
      http.post(AUTH_URL + '/opt/forgot-password', param).then(response => {
         return callback(response)
      })
   },
   validateacnt: function (param, callback) {
      http.post(AUTH_URL + '/opt/validate-account', param).then(response => {
         return callback(response)
      })
   },
   resetpassword: function (param, callback) {
      http.post(AUTH_URL + '/opt/change-password', param).then(response => {
         return callback(response)
      })
   },
   getSettingDetails: function (param, callback) {
      http.post(API_URL + '/settings/settingsDetailsById', param).then(response => {
         return callback(response)
      })
   },
   getHospDoc: function (param, callback) {
      http.post(API_URL + '/settings/getHospDoc', param).then(response => {
         return callback(response)
      })
   },
   privileges: (callback) => {
      http.post(API_URL + '/privileges/list').then(response => {
         if (response.data) {
            return callback(response.data)
         } else {
            return callback(null)
         }
      })
   },
   addprivileges: function (param, callback) {
      http.post(API_URL + '/privileges/add', param).then(response => {
         return callback(response)
      })
   },
   getprivileges: function (param, callback) {
      http.post(API_URL + '/privileges/getRoles', param).then(response => {
         return callback(response)
      })
   },
   getnameprivileges: function (param, callback) {
      http.post(API_URL + '/privileges/roleList', param).then(response => {
         return callback(response)
      })
   },
   getprivilegesbyId: function (param, callback) {
      http.post(API_URL + '/privileges/getRoleById', param).then(response => {
         return callback(response)
      })
   },
   updateprivileges: function (param, callback) {
      http.post(API_URL + '/privileges/update', param).then(response => {
         return callback(response)
      })
   },
   addUser: function (param, callback) {
      http.post(AUTH_URL + '/opt/register', param).then(response => {
         return callback(response)
      })
   },
   getAdminUserList: function (param, callback) {
      http.post(API_URL + '/employee/list', param).then(response => {
         return callback(response)
      })
   },
   updateEmployeeStatus: function (param, callback) {
      http.post(API_URL + '/employee/updateStatus', param).then(response => {
         return callback(response)
      })
   },
   getEmployeesid: function (param, callback) {
      http.post(API_URL + '/employee/getAEmpById', param).then(response => {
         1
         return callback(response)
      })
   },
   updateUser: function (param, callback) {
      http.post(API_URL + '/employee/update', param).then(response => {
         return callback(response)
      })
   },
   getHospitalReport: function (param, callback) {
      http.post(API_URL + '/reports/dashboard', param).then(response => {
         return callback(response)
      })
   },
   getServiceTypes: function (param, callback) {
      http.post(API_URL + '/hospital/getServiceTypes', param).then(response => {
         return callback(response)
      })
   },
   changeStatus: function (param, callback) {
      http.post(API_URL + '/hospital/statusChange', param).then(response => {
         return callback(response)
      })
   },
   getHospitalName: function (param, callback) {
      http.post(API_URL + '/hospital/getHospitalName', param).then(response => {
         return callback(response)
      })
   },
   getGeneralSettings: function (callback) {
      http.get(API_URL + '/settings/getVCConsultations').then(response => {
         return callback(response)
      })
   },
   getPackageName: function (param,callback) {
      http.post(API_URL + '/hospital/markupDropData',param).then(response => {
         return callback(response)
      })
   },
   hospitalList: function (param, callback) {
      http.post(API_URL + '/hospital/listMarkup', param).then(response => {
         return callback(response)
      })
   },
   addMarkUp: function(param,callback) {
      http.post(API_URL + '/hospital/addMarkup', param).then(response =>{
         return callback(response)
      })
   },
   editMarkUp: function(param,callback) {
      http.post(API_URL + '/hospital/editMarkup', param).then(response =>{
         return callback(response)
      })
   },
   showMarkUp: function(param,callback) {
      http.post(API_URL + '/hospital/idMarkup', param).then(response =>{
         return callback(response)
      })
   },

   saveGeneralSettings: function (param, callback) {
      http.post(API_URL + '/settings/addVCCons', param).then(response => {
         return callback(response)
      })
   },
   getLevelData: function (param, callback) {
      http.post(API_URL + '/settings/getVCData', param).then(response => {
         return callback(response)
      })
   },
   getAppointments: function (param, callback) {
      http.post(ADMIN_SERVICE_URL + '/appointments/list', param).then(response => {
         return callback(response)
      })
   },
   getBupaAppointments: function (param, callback) {
      http.post(API_URL + '/bupa/refillist', param).then(response => {
         return callback(response)
      })
   },
   getBupaAppointmentId: function (param, callback) {
      http.post(API_URL + '/bupa/id', param).then(response => {
         return callback(response)
      })
   },
   getBupaAdandoned: function (param, callback) {
      http.post(API_URL + '/bupa/prebooklist', param).then(response => {
         return callback(response)
      })
   },
   getBupaAbandonedId: function (param, callback) {
      http.post(API_URL + '/bupa/prebookid', param).then(response => {
         return callback(response)
      })
   },
   getAppointmentslist: function (param, callback) {
      http.post(API_URL + '/appointments/prebooklist', param).then(response => {
         return callback(response)
      })
   },
   getAppointmentbyId: function (param, callback) {
      http.post(API_URL + '/appointments/id', param).then(response => {
         return callback(response)
      })
   },
   getAppointmentId: function (param, callback) {
      http.post(API_URL + '/appointments/prebookid', param).then(response => {
         return callback(response)
      })
   },
   getInvoiceData: function (param, callback) {
      http.post(API_URL + '/appointments/invoice', param).then(response => {
         return callback(response)
      })
   },
   cancelamendment: function (param, callback) {
      http.post(API_URL + '/appointments/cancelAmendment', param).then(response => {
         return callback(response)
      })
   },
   downloadfile: function (param, callback) {
      http.get(API_URL + '/general/download/?mtype=' + param.mtype + '&eid=' + param.eid).then(response => {
         return callback(response)
      })
   },
   downloadMarkup: function (param, callback) {
      http.get(API_URL + '/general/markupdownload/?mtype=' + '&eid=' + param.eid).then(response => {
         return callback(response)
      })
   },
   discountlist: function (param, callback) {
      http.post(API_URL + '/discount/list', param).then(response => {
         return callback(response)
      })
   },
   getdiscountdetails: function (param, callback) {
      http.post(API_URL + '/discount/detailsList', param).then(response => {
         return callback(response)
      })
   },
   getdiscountempdetails: function (param, callback) {
      http.post(API_URL + '/discount/hospEmpList', param).then(response => {
         return callback(response)
      })
   },
   adddiscount: function (param, callback) {
      http.post(API_URL + '/discount/add', param).then(response => {
         return callback(response)
      })
   },
   updatediscountstatus: function (param, callback) {
      http.post(API_URL + '/discount/updateDiscStatus', param).then(response => {
         return callback(response)
      })
   },
   refundpay: function (param, callback) {
      http.post(API_URL + '/pay/cout/refundTransaction', param).then(response => {
         return callback(response)
      })
   },
   acceptRequest: function (param, callback) {
      http.post('https://us-central1-sanar-231614.cloudfunctions.net/topics/acceptChatRequest', param).then(response => {
         return callback(response)
      })
   },
   endChat: function (param, callback) {
      http.post('https://us-central1-sanar-231614.cloudfunctions.net/topics/endChat', param).then(response => {
         return callback(response)
      })
   },
   enquiryList: function (param, callback) {
      http.post(STATIC_URL + '/web/formRequest/list', param).then(response => {
         return callback(response)
      })
   },
   verifywebuser: function (param, callback) {
      http.post(STATIC_URL + '/web/formRequest/verify', param).then(response => {
         return callback(response)
      })
   },
   updatePackagesData: function (param, callback) {
      http.post(API_URL + '/packages/update', param).then(response => {
         return callback(response)
      })
   },
   getPackageList: function (param, callback) {
      http.post(API_URL + '/packages/list', param).then(response => {
         return callback(response)
      })
   },
   addPackage: function (param, callback) {
      http.post(API_URL + '/packages/add', param).then(response => {
         return callback(response)
      })
   },
   updatePackageStatus: function (param, callback) {
      http.post(API_URL + '/packages/updateStatus', param).then(response => {
         return callback(response)
      })
   },
   getPackageData: function (param, callback) {
      http.post(API_URL + '/packages/getData', param).then(response => {
         return callback(response)
      })
   },
   deleteCityData: function (param, callback) {
      http.post(API_URL + '/packages/deleteCity', param).then(response => {
         return callback(response)
      })
   },
   getPackageCitiesData: function (param, callback) {
      http.post(API_URL + '/packages/cities', param).then(response => {
         return callback(response)
      })
   },
   getpackagestaticdata: function (callback) {
      http.get(API_URL + '/packages/getStaticDataforPackages').then(response => {
         return callback(response)
      })
   },
   getInstrucitonsforTests: function (param, callback) {
      http.post(API_URL + '/packages/getInstructionsforTests', param).then(response => {
         return callback(response)
      })
   },
   getInstructionsforTask: function (param, callback) {
      http.post(API_URL + '/packages/getInstructionsforTask', param).then(response => {
         return callback(response)
      })
   },
   qitafEarn: function(param,callback) {
      http.post(API_URL + '/qitaf/earnList',param).then(response => {
         return callback(response)
      })
   },
   qitafBurn: function(param,callback) {
      http.post(API_URL + '/qitaf/burnList',param).then(response => {
         return callback(response)
      })
   },
   singleqitafEarn: function(param,callback) {
      http.post(API_URL + '/qitaf/singleQitafEarn',param).then(response => {
         return callback(response)
      })
   },
   singleqitafBurn: function(param,callback) {
      http.post(API_URL + '/qitaf/singleQitafBurn',param).then(response => {
         return callback(response)
      })
   },
   viewCoupon: function (param, callback) {
      http.post(API_URL + '/coupons/getSingleCoupon', param).then(response => {
         return callback(response)
      })
   },
   couponList: function (param, callback) {
      http.post(API_URL + '/coupons/list', param).then(response => {
         return callback(response)
      })
   },
   couponHistory: function (param, callback) {
      http.post(API_URL + '/coupons/history', param).then(response => {
         return callback(response)
      })
   },
   updateCoupon: function (param, callback) {
      http.post(API_URL + '/coupons/update', param).then(response => {
         return callback(response)
      })
   },
   // get dept list for coupons
   getDeptList: function (param, callback) {
      http.post(API_URL + '/coupons/getHsptDeptList', param).then(response => {
         return callback(response)
      })
   },
   // get hosp list for coupon
   getHospList: function (param, callback) {
      http.post(API_URL + '/coupons/getHospList', param).then(response => {
         return callback(response)
      })
   },
   // get doctor list for coupons
   getDoctorList: function (param, callback) {
      http.post(API_URL + '/coupons/getHospDoctors', param).then(response => {
         return callback(response)
      })
   },
   // get treatment list for Physio coupon
   getTreatmentList: function (param, callback) {
      http.post(API_URL + '/coupons/getPhysioTreatmentsList', param).then(response => {
         return callback(response)
      })
   },
   // get physitherapists list for coupon
   getPhysioList: function (param, callback) {
      http.post(API_URL + '/coupons/getPhysioTherapistList', param).then(response => {
         return callback(response)
      })
   },
   // get Nurse Task list for coupon
   getTaskList: function (param, callback) {
      http.post(API_URL + '/coupons/getNurseTasks', param).then(response => {
         return callback(response)
      })
   },
   // get Lab Test list for coupon
   getTestList: function (param, callback) {
      http.post(API_URL + '/coupons/getLabTests', param).then(response => {
         return callback(response)
      })
   },
   // get user(patient) list for coupon
   getUserList: function (param, callback) {
      http.post(API_URL + '/coupons/getSanarUsers', param).then(response => {
         return callback(response)
      })
   },
   createCoupon: function (param, callback) {
      http.post(API_URL + '/coupons/create', param).then(response => {
         return callback(response)
      })
   },
   getCouponDetails: function (param, callback) {
      http.post(API_URL + '/coupons/getSingleCoupon', param).then(response => {
         return callback(response)
      })
   },
   updateCoupon: function (param, callback) {
      http.post(API_URL + '/coupons/update', param).then(response => {
         return callback(response)
      })

   },
   getOffices: function (callback) {
      http.get(API_URL + '/general/officeDetails').then(response => {
         return callback(response)
      })
   },
   getbookingCountries: function (callback) {
      http.get(API_URL + '/general/bookingCountries').then(response => {
         return callback(response)
      })
   },
   getOfficeDetails: function (callback) {
      http.get(API_URL + '/general/officeDetails').then(response => {
         return callback(response)
      })
   },
   getRescheduleDetails: function (param, callback) {
      http.post(API_URL + '/reschedule/appointmentDetails', param).then(response => {
         return callback(response)
      })
   },

   getRescheduleHospitalDetails: function (param, callback) {
      http.post(API_URL + '/reschedule/hospitalDetails', param).then(response => {
         return callback(response)
      })
   },
   getReschedulePatientDetails: function (param, callback) {
      http.post(API_URL + '/reschedule/patientDetails', param).then(response => {
         return callback(response)
      })
   },
   getRescheduleEmployeeDetails: function (param, callback) {
      http.post(API_URL + '/reschedule/employeeDetails', param).then(response => {
         return callback(response)
      })
   },
   getSlotsDuration: function (param, callback) {
      http.post(API_URL + '/reschedule/getSlotsDuration', param).then(response => {
         return callback(response)
      })
   },
   getAvailableSlots: function (param, callback) {
      http.post(API_URL + '/reschedule/availableSlots', param).then(response => {
         return callback(response)
      })
   },
   updateSchedule: function (param, callback) {
      http.post(API_URL + '/reschedule/update', param).then(response => {
         return callback(response)
      })
   },
   getAppointmentStatusList: function (callback) {
      http.post(API_URL + '/reschedule/appointmentStatus').then(response => {
         return callback(response)
      })
   },
   changeAppointmentStatus: function (param, callback) {
      http.post(API_URL + '/reschedule/updateAppStatus', param).then(response => {
         return callback(response)
      })
   },
   cmsPriceList:function(param,callback){
      http.post(API_URL + '/cms/pricesList', param).then(response => {
         return callback(response)
      })
   },
   cmsNphiesList:function(param,callback){
      http.post(API_URL + '/cms/nphiesList', param).then(response => {
         return callback(response)
      })
   },
   cmsList: function (param, callback) {
      http.post(API_URL + '/cms/list', param).then(response => {
         return callback(response)
      })
   },
   cmsAdd: function (param, callback) {
      http.post(API_URL + '/cms/add', param).then(response => {
         return callback(response)
      })
   },
   getHvPriceList:function(param,callback){
      http.post(API_URL + '/cms/getHvPriceList', param).then(response => {
         return callback(response)
      })
   },
   addHvPriceConfig: function (param, callback) {
      http.post(API_URL + '/cms/addHvPriceConfig', param).then(response => {
         return callback(response)
      })
   },
   getHvPriceById: function (param, callback) {
      http.post(API_URL + '/cms/getHvPriceById', param).then(response => {
         return callback(response)
      })
   },
   cmsId: function (param, callback) {
      http.post(API_URL + '/cms/id', param).then(response => {
         return callback(response)
      })
   },
   cmsEdit: function (param, callback) {
      http.post(API_URL + '/cms/edit', param).then(response => {
         return callback(response)
      })
   },
   addCMSPrice:function(param, callback){
      http.post(API_URL + '/cms/addPrice', param).then(response => {
         return callback(response)
      })
   },
   updateCMSPRICE:function(param, callback){
      http.post(API_URL + '/cms/updatePrice', param).then(response => {
         return callback(response)
      })
   },
   getInstructionsforCategory: function (param, callback) {
      http.post(API_URL + '/cms/categoryList', param).then(response => {
         return callback(response)
      })
   },
   getEmployeelistforSettlements: function (param, callback) {
      http.post(API_URL + '/hospital/empListForSettlementView', param).then(response => {
         return callback(response)
      })
   },
   cmsStatusUpdate: function (param, callback) {
      http.post(API_URL + '/cms/updateStatus', param).then(response => {
         return callback(response)
      })
   },
   getGeneralData: function (param, callback) {
      http.post(API_URL + '/general/getStaticData', param).then(response => {
         return callback(response)
      })
   },
   getUserData: function (param, callback) {
      http.post(API_URL + '/patients/userrevenue', param).then(response => {
         return callback(response)
      })
   },
   getDepSale: function (param, callback) {
      http.post(API_URL + '/patients/depsales', param).then(response => {
         return callback(response)
      })
   },
   getpersonalDetails: function (param, callback) {
      http.post(API_URL + '/patients/personalDetails', param).then(response => {
         return callback(response)
      })
   },
   getSanarRelatives: function (param, callback) {
      http.post(API_URL + '/patients/getSanarRelatives', param).then(response => {
         return callback(response)
      })
   },
   getSavedPatientsDetails: function (param, callback) {
      http.post(API_URL + '/patients/getSavedPatientsDetails', param).then(response => {
         return callback(response)
      })
   },
   getcouponDetails: function (param, callback) {
      http.post(API_URL + '/patients/couponDetails', param).then(response => {
         return callback(response)
      })
   },
   getRecordList: function (param, callback) {
      http.post(API_URL + '/patients/recordslist', param).then(response => {
         return callback(response)
      })
   },
   getSanarRelatives: function (param, callback) {
      http.post(API_URL + '/patients/getSanarRelatives', param).then(response => {
         return callback(response)
      })
   },
   getTaskCount: function (param, callback) {
      http.post(API_URL + '/patients/taskcount', param).then(response => {
         return callback(response)
      })
   },
   getTestCount: function (param, callback) {
      http.post(API_URL + '/patients/testcount', param).then(response => {
         return callback(response)
      })
   },
   getTreatmentCount: function (param, callback) {
      http.post(API_URL + '/patients/treatmentcount', param).then(response => {
         return callback(response)
      })
   },
   getTrackAppointments: function (param, callback) {
      http.post(API_URL + '/patients/trackAppointments', param).then(response => {
         return callback(response)
      })
   },
   appointmentBriefList: function (param, callback) {
      http.post(API_URL + '/patients/appointmentBriefListV1', param).then(response => {
         return callback(response)
      })
   },
   appointmentDetails: function (param, callback) {
      http.post(API_URL + '/patients/appointmentDetailsV1', param).then(response => {
         return callback(response)
      })
   },
   getSequenceList: function (param, callback) {
      http.post(API_URL + '/cms/seqList', param).then(response => {
         return callback(response)
      })
   },
   getServiceList:function (param,callback){
      http.post(API_URL + '/services/list', param).then(response => {
         return callback(response)
      })
   },
   editSequenceList: function (param, callback) {
      http.post(API_URL + '/cms/updateMany', param).then(response => {
         return callback(response)
      })
   },
   editProductList: function (param, callback) {
      http.post(API_URL + '/services/update', param).then(response => {
         return callback(response)
      })
   },
   editProductId:function (param, callback) {
      http.post(API_URL + '/services/id', param).then(response => {
         return callback(response)
      })
   },
   getSearchData: function (param, callback) {
      http.post(PH_URL + '/v5/manual/users', param).then(response => {
         return callback(response)
      })
   },
   getBrowseData: function (param, callback) {
      http.post(PH_URL + '/v5/manual/browse', param).then(response => {
         return callback(response)
      })
   },
   getPreData: function (callback) {
      http.post(PH_URL + '/v5/manual/preData').then(response => {
         return callback(response)
      })
   },
   getTransitionData: function (callback) {
      http.post(API_URL + '/cms/addTransData').then(response => {
         return callback(response)
      })
   },
   verifyUser:function (param, callback) {
      http.post(COM_URL + '/verify/checkUser', param).then(response => {
         return callback(response)
      })
   },
   registerUser:function(param, callback){
      http.post(COM_URL + '/verify/register', param).then(response => {
         return callback(response)
      })
   },
   manualprofile:function(param, callback){
      http.post(PH_URL + '/v5/manual/profile', param).then(response => {
         return callback(response)
      })
   },
   getPatients:function(param, callback){
      http.post(PH_URL + '/v5/manual/patients', param).then(response => {
         return callback(response)
      })
   },
   manualPrebook:function(param, callback){
      http.post(PH_URL + '/v5/manual/prebookV1', param).then(response => {
         return callback(response)
      })
   },
   addPatient:function(param,callback){
      http.post(PH_URL + '/v5/manual/addPatient', param).then(response => {
         return callback(response)
      })
   },
   patientDetails:function(param,callback){
      http.post(PH_URL + '/v5/manual/patientDetails', param).then(response => {
         return callback(response)
      })
   },
   followapplist:function(param,callback){
      http.post(PH_URL + '/v5/followUp/apntList', param).then(response => {
         return callback(response)
      })
   },
   followupBooking:function(param,callback){
      http.post(PH_URL + '/v5/followUp/browseDate', param).then(response => {
         return callback(response)
      })
   },
   confirmfollowup:function(param,callback){
      http.post(PH_URL + '/v5/followUp/confirm', param).then(response => {
         return callback(response)
      })
   },
   addEclinic:function(param,callback){
      http.post(API_URL + '/eclinic/add', param).then(response => {
         return callback(response)
      })
   },
   updateEclinic:function(param,callback){
      http.post(API_URL + '/eclinic/edit', param).then(response => {
         return callback(response)
      })
   },
   clinicList:function(param,callback){
      http.post(API_URL + '/eclinic/list', param).then(response => {
         return callback(response)
      })
   },
   getClinicDetails:function(param,callback){
      http.post(API_URL + '/eclinic/id', param).then(response => {
         return callback(response)
      })
   },
   updateClinicStatus:function(param,callback){
      http.post(API_URL + '/eclinic/updateStatus', param).then(response => {
         return callback(response)
      })
   },
   serviceCodeList:function(callback){
      http.post(API_URL + '/cms/insPrcData').then(response => {
         return callback(response)
      })
   },
   getSingleprice:function(param,callback){
      http.post(API_URL + '/cms/singlePrice',param).then(response => {
         return callback(response)
      })
   },
   translateAddData:function(param,callback){
      http.post(API_URL + '/cms/addTransData', param).then(response => {
         return callback(response)
      })
   },
   translateUpdateData:function(param,callback){
      http.post(API_URL + '/cms/updateTransData',param).then(response => {
         return callback(response)
      })
   },
   transDataList:function(param,callback){
      http.post(API_URL + '/cms/transDataList',param).then(response => {
         return callback(response)
      })
   },
   getTransDataId:function(param,callback){
      http.post(API_URL + '/cms/transDataByKey',param).then(response => {
         return callback(response)
      })
   },
   groupCodeList: function(callback){
      http.post(API_URL + '/cms/groupCodeList').then(response => {
         return callback(response)
      })
   },
   addIcd: function(param,callback){
      http.post(API_URL + '/cms/addIcd',param).then(response => {
         return callback(response)
      })
   },
   singleIcd: function(param,callback) {
      http.post(API_URL + '/cms/singleIcd',param).then(response => {
         return callback(response)
      })
   },
   updateIcd: function(param,callback) {
      http.post(API_URL + '/cms/updateIcd',param).then(response => {
         return callback(response)
      })
   },
   doctoList: function(param,callback) {
      http.post(API_URL + '/cms/doctors',param).then(response => {
         return callback(response)
      })
   },
   provoderList: function(param,callback) {
      http.post(STATIC_URL + '/general/getStaticData',param).then(response => {
         return callback(response)
      })
   },
   savedCards: function(param,callback) {
      http.post(API_URL + '/patients/savedCards',param).then(response => {
         return callback(response)
      })
   },
   ratingList: function(param,callback) {
      http.post(API_URL + '/rating/list',param).then(response => {
         return callback(response)
      })
   },
   ratingDetails: function(param,callback) {
      http.post(API_URL + '/rating/details',param).then(response => {
         return callback(response)
      })
   },
   ratingPublish: function(param,callback) {
      http.post(API_URL + '/rating/publish',param).then(response => {
         return callback(response)
      })
   },
   ratingReply: function(param,callback) {
      http.post(API_URL + '/rating/reply',param).then(response => {
         return callback(response)
      })
   },
   getWalletSources: function(callback) {
      http.get(API_URL + '/wallet/getWalletSources').then(response => {
         return callback(response)
      })
   },
   getWalletDetails: function(param, callback) {
      http.post(API_URL + '/wallet/walletDetails', param).then(response => {
         return callback(response)
      })
   },
   getSelectedServicePrice: function (param, callback) {
      http.post(PH_URL + '/v5/manual/manualprice', param).then(response => {
         return callback(response)
      })
   },
   getSanarEmployees: function(callback) {
      http.get(API_URL + '/wallet/getSanarEmployees').then(response => {
         return callback(response)
      })
   },
   getOperationDepartments: function(callback) {
      http.get(API_URL + '/wallet/getOperationDepartments').then(response => {
         return callback(response)
      })
   },
   walletAdd: function(param,callback) {
      http.post(API_URL + '/wallet/add',param).then(response => {
         return callback(response)
      })
   },
   walletCards: function(param,callback) {
      http.post(API_URL + '/wallet/cards',param).then(response => {
         return callback(response)
      })
   },
   walletTransactions: function(param,callback) {
      http.post(API_URL + '/wallet/transactions',param).then(response => {
         return callback(response)
      })
   },
   userWalletCards: function(param,callback) {
      http.post(API_URL + '/patients/wallet/cards',param).then(response => {
         return callback(response)
      })
   },
   userWalletTransactions: function(param,callback) {
      http.post(API_URL + '/patients/wallet/transactions',param).then(response => {
         return callback(response)
      })
   },
   unusedCards:function(param,callback) {
      http.get(API_URL + '/wallet/unusedCards/'+param.uid).then(response => {
         return callback(response)
      })
   },
   reverseWallet: function(param,callback) {
      http.post(API_URL + '/wallet/card/reverse',param).then(response => {
         return callback(response)
      })
   },
   adjustCards: function(param,callback) {
      http.get(API_URL + '/wallet/adjustCards/'+param.uid).then(response => {
         return callback(response)
      })
   },
   debitFromCard: function(param,callback) {
      http.post(API_URL + '/wallet/card/debit',param).then(response => {
         return callback(response)
      })
   },
   mainUserDetails: function(param,callback) {
      http.get(API_URL + '/wallet/user/details/'+param.uid).then(response => {
         return callback(response)
      })
   },
   paymentAmountSplitCheck: function(param,callback) {
      http.post(API_URL + '/wallet/paymentAmountSplitCheck',param).then(response => {
         return callback(response)
      })
   },
   getTaskData: function (param, callback) {
      http.post(STATIC_URL + '/general/getStaticData', param).then(response => {
         return callback(response)
      })
   },
   getMenuData: function (param, callback) {
      http.post(API_URL + '/menu', param).then(response => {
         return callback(response)
      })
   },
   getAllDetails: function (param, callback) {
      http.post(PH_URL + '/v5/manual/allDetails', param).then(response => {
         return callback(response)
      })
   },
   getAllDetailsV1: async function (param) {
      return await http.post(PH_URL + '/v5/manual/allDetails', param)
   },
   getLabTechSlots: function (param, callback) {
      http.post(PH_URL + '/v5/manual/labBrowse', param).then(response => {
         return callback(response)
      })
   },
   getTaskSlots: function (param, callback) {
      http.post(PH_URL + '/v5/manual/nurseBrowse', param).then(response => {
         return callback(response)
      })
   },
   getPhysioBrowse: function (param, callback) {
      http.post(PH_URL + '/v5/manual/physioBrowse', param).then(response => {
         return callback(response)
      })
   },
   geteClinics: function (param, callback) {
      http.post(PH_URL + '/v6/generic/eclincs', param).then(response => {
         return callback(response)
      })
   },
   getDepartments: function (param, callback) {
      http.post(PH_URL + '/v6/generic/departments', param).then(response => {
         return callback(response)
      })
   },
   addInsurance: function (param, callback) {
      http.post(PH_URL + '/v5/manual/updatePatientProfile', param).then(response => {
         return callback(response)
      })
   },
   getMultiInsurance: function (param, callback) {
      http.post(PH_URL + '/v5/waseel/checkBupaMembershipManual', param).then(response => {
         return callback(response)
      })
   },
   getInsuranceDetails: function (param, callback) {
      http.post(PH_URL + '/v5/manual/insuranceDetails', param).then(response => {
         return callback(response)
      })
   },
   getInsurancePrice: function (param, callback) {
      http.post(PH_URL + '/v5/manual/insurancePrice', param).then(response => {
         return callback(response)
      })
   },

  getPatientReferrals: function (param, callback) {
      http.post(PH_URL + '/v5/manual/patientReferrals', param).then(response => {
         return callback(response)
      })
   },
   
   getMokafaaList: function (param, callback) {
      http.post(API_URL + '/mokafaa/list', param).then(response => {
         return callback(response)
      })
   },
   reverseMokafaa: function (param, callback) {
      http.post(API_URL + '/mokafaa/reverseRedeem', param).then(response => {
         return callback(response)
      })
   },
   reverseQitaf: function (param, callback) {
      http.post(API_URL + '/qitaf/reverseRedeem', param).then(response => {
         return callback(response)
      })
   },
   reverseTransaction: function (param, callback) {
      http.post(API_URL + '/pay/cout/reverseTransaction', param).then(response => {
         return callback(response)
      })
   },
   fullcancelAppointment: function (param, callback) {
      http.post(API_URL + '/appointments/fullCancelAppointment', param).then(response => {
         return callback(response)
      })
   },
   multiRefundpay: function (param, callback) {
      http.post(API_URL + '/pay/cout/multiRefundTransaction', param).then(response => {
         return callback(response)
      })
   },
   cmsgetService: function (param, callback) {
      http.post(API_URL + '/cms/getService', param).then(response => {
         return callback(response)
      })
   },
   getCustomTaskSlots: function (param, callback) {
      http.post(PH_URL + '/v5/manual/customNurseBrowse', param).then(response => {
         return callback(response)
      })
   },
   getCustomDeptSlots: function (param, callback) {
      http.post(PH_URL + '/v5/manual/customDoctorBrowse', param).then(response => {
         return callback(response)
      })
   },
   getCustomPhysioBrowse: function (param, callback) {
      http.post(PH_URL + '/v5/manual/customPhysioBrowse', param).then(response => {
         return callback(response)
      })
   },
   getCustomLabtechBrowse: function (param, callback) {
      http.post(PH_URL + '/v5/manual/customLabtechBrowse', param).then(response => {
         return callback(response)
      })
   },
   getCreditUserList: function (param, callback) {
      http.post(API_URL + '/cms/creditUserList', param).then(response => {
         return callback(response)
      })
   },
   getCreditUserPrice: function (param, callback) {
      http.post(PH_URL + '/v5/manual/creditUserPrice', param).then(response => {
         return callback(response)
      })
   },
   getCustomPrebook: function (param, callback) {
      http.post(PH_URL + '/v5/manual/customPrebook', param).then(response => {
         return callback(response)
      })
   },
   getcustomservices: function (param, callback) {
      http.post(API_URL + '/cms/customservices', param).then(response => {
         return callback(response)
      })
   },
   getMultiSlotPriceConfig: function (param, callback) {
      http.post(API_URL + '/doctor/multislotPriceConfigOp', param).then(response => {
         return callback(response)
      })
   },
   getMultiSlotDurationList: function (param, callback) {
      http.post(API_URL + '/settings/getMultiSlotDurationList', param).then(response => {
         return callback(response)
      })
   },
   getmultiSpecialities: function (callback) {
      http.get(API_URL + '/settings/getMutlislotSpecialities').then(response => {
         return callback(response)
      })
   },
   getmultiDuration: function (param,callback) {
      http.post(API_URL + '/settings/getMultiSlotDuration',param).then(response => {
         return callback(response)
      })
   },
   updateMultiSlotDuration: function (param,callback) {
      http.post(API_URL + '/settings/updateMultiSlotDuration',param).then(response => {
         return callback(response)
      })
   },
   getMultiSlotPrice: function (param,callback) {
      http.post(API_URL + '/settings/getMultiSlotPrice',param).then(response => {
         return callback(response)
      })
   },
   updateMultiSlotPrice: function (param,callback) {
      http.post(API_URL + '/settings/updateMultiSlotPrice',param).then(response => {
         return callback(response)
      })
   },
   yakeenDetails: function (param,callback) {
      http.post(PH_URL + '/v6/yakeen/details',param).then(response => {
         return callback(response)
      })
   },
   yakeenUpdateDetails: function (param,callback) {
      http.post(PH_URL + '/v5/manual/yakeenUpdateProfile',param).then(response => {
         return callback(response)
      })
   },
   saveInsuranceLogo: function (param,callback) {
      http.post(API_URL + '/inslogo/add',param).then(response => {
         return callback(response)
      })
   },
   listInsuranceLogo: function (callback) {
      http.get(API_URL + '/inslogo/fetch').then(response => {
         return callback(response)
      })
   },
   getBupaSlots: function (param,callback) {
      http.post(API_URL + '/bupa/slots', param).then(response => {
         return callback(response)
      })
   },
   getDepartmentList: function (callback) {
      http.get(API_URL + '/bupa/departments').then(response => {
         return callback(response)
      })
   },
   searchPatient: function (param,callback) {
      http.post(API_URL + '/bupa/patientDetails',param).then(response => {
         return callback(response)
      })
   },
   medicalProblems: function (param, callback) {
      http.post(API_URL + '/bupa/medicalProblems', param).then(response => {
         return callback(response)
      })
   },
   addPriscription: function (param, callback) {
      http.post(API_URL + '/bupa/drugsList', param).then(response => {
         return callback(response)
      })
   },
   getPriscription: function (callback) {
      http.get(API_URL + '/bupa/getPrescriptionMasterData').then(response => {
         return callback(response)
      })
   },
   getPatients: function (param, callback) {
      http.post(PH_URL + '/v5/manual/patients', param).then(response => {
         return callback(response)
      })
   },
   getPharmform: function (param, callback) {
      http.post(API_URL + '/bupa/prescription/data', param).then(response => {
         return callback(response)
      })
   },
   bookBupa: function (param, callback) {
      http.post(API_URL + '/bupa/book', param).then(response => {
         return callback(response)
      })
   },
   getSalesByPatientAge: function (param, callback) {
      http.post(API_URL + '/dashboardV3/ageAndgender', param).then(response => {
         return callback(response)
      });
   },
   getSalesByCity: function (param, callback) {
      http.post(API_URL + '/dashboardV3/cityWiseData', param).then(response => {
         return callback(response)
      });
   },
   getProductDetails: function (param, callback) {
      http.post(API_URL + '/dashboardV3/productDetail', param).then(response => {
         return callback(response)
      });
   },
   getNewStaticData: function(callback){
      http.get(API_URL + '/dashboardV3/staticData').then(response => {
         return callback(response)
      });
   },
   getAverageSales: function (param, callback) {
      http.post(API_URL + '/dashboardV3/averageSale', param).then(response => {
         return callback(response)
      });
   },
   getNotifications: function (request, callback) {
      http.post(NOTIFICATION + '/v1/opt/notifications', request).then(response => {
         return callback(response)
      });
   },
   getNotifyCount: function(callback) {
      http.get(API_URL + `/notification/count`).then(response => {
         return callback(response)
      });
   },
   updateNotification: function(param, callback) {
      http.post(NOTIFICATION + '/v1/opt/notifications/updateStatus', param).then(response => {
         return callback(response)
      })
   },
   dashboardSlots: function (payload, callback) {
      http.post(API_URL + '/dashboard/slotData', payload).then(response => {
         return callback(response)
      })
   },
   searchandConversion: function(payload,callback) {
      http.post(API_URL + '/dashboardV3/searchConversion',payload).then(response => {
         return callback(response)
      });
   },
   telemedicinConversion: function(payload,callback) {
    http.post(API_URL + '/dashboardV3/eclinicSearchConversion',payload).then(response => {
       return callback(response)
    });
 },
   searchandData: function(callback) {
      http.get(API_URL + '/dashboardV3/searchData').then(response => {
         return callback(response)
      });
   },
   getReferralList: function (param, callback) {
      http.post(API_URL + '/referrals/list', param).then(response => {
         return callback(response)
      });
   },
   getReferralByID: function (param, callback) {
      http.post(API_URL + '/referrals/id', param).then(response => {
         return callback(response)
      });
   },
   getReferralRevenueList: function (param, callback) {
      http.post(API_URL + '/referrals/revenue_report', param).then(response => {
         return callback(response)
      });
   },
   getReferralRevenueDetail: function (param, callback) {
      http.post(API_URL + '/referrals/revenue_id', param).then(response => {
         return callback(response)
      });
   },
   getCMSRefferalList: function (param, callback) {
      http.post(API_URL + '/cms/list', param).then(response => {
         return callback(response)
      });
   },
   saveCmsLabTest : function(param, callback){
      http.post(API_URL + '/cms/add', param).then(response => {
         return callback(response)
      })
 },
 getCmsLabTestList : function(param, callback){
   http.post(API_URL + '/cms/list', param).then(response => {
      return callback(response)
   })
},
  
getCmsLabTestDetail : function(param, callback){
   http.post(API_URL + '/cms/id', param).then(response => {
      return callback(response)
   })
},
cmsLabTestUpdate : function(param, callback){
   http.post(API_URL + '/cms/edit', param).then(response => {
      return callback(response)
   })
},
   
   editCommission: function (param, callback) {
      http.post(API_URL + '/cms/edit', param).then(response => {
         return callback(response)
      });
   },
   addRefferalCommission: function (param, callback) {
      http.post(API_URL + '/cms/add', param).then(response => {
         return callback(response)
      });
   },
   getCMSRefferalById: function (param, callback) {
      http.post(API_URL + '/cms/id', param).then(response => {
         return callback(response)
      });
   },
   DeleteTest: function (param, callback) {
      http.post(API_URL + '/cms/removeTest', param).then(response => {
         return callback(response)
      });
   },
   doctorsList: function (param, callback) {
      http.post(API_URL + '/dropdown/docList', param).then(response => {
         return callback(response)
      });
   },
   productsList: function (callback) {
      http.get(API_URL + '/dashboardV3/products').then(response => {
         return callback(response)
      });
   },
   addSeo: function (param, callback) {
      http.post(API_URL + '/seo/add', param).then(response => {
         return callback(response)
      });
   },
   seoList: function (param, callback) {
      http.post(API_URL + '/seo/list', param).then(response => {
         return callback(response)
      });
   },
   seoId: function (param, callback) {
      http.post(API_URL + '/seo/id', param).then(response => {
         return callback(response)
      });
   },
   updateSeo: function (param, callback) {
      http.post(API_URL + '/seo/edit', param).then(response => {
         return callback(response)
      });
   },
   seoStatus: function (param, callback) {
      http.post(API_URL + '/seo/updateStatus', param).then(response => {
         return callback(response)
      });
   },
   addPharmacy: function (param, callback) {
      http.post(PHARMACY_URL + '/api/operation/drugstore/create', param).then(response => {
         return callback(response)
      });
   },
   listPharmacy: function (param, callback) {
      http.post(PHARMACY_URL + '/api/operation/drugstore/list', param).then(response => {
         return callback(response)
      });
   },
   editPharmacy: function (param, callback) {
      http.get(PHARMACY_URL + '/api/operation/drugstore/' + param.store_id).then(response => {
         return callback(response)
      });
   },
   updatePharmacy: function (param, callback) {
      http.post(PHARMACY_URL + '/api/operation/drugstore/edit', param).then(response => {
         return callback(response)
      });
   },
   updatePharmacyStatus: function (param, callback) {
      http.post(PHARMACY_URL + '/api/operation/drugstore/updateStaus', param).then(response => {
         return callback(response)
      });
   },
   childPharmacyList: function ( callback) {
      http.post(PHARMACY_URL + '/api/operation/drugstore/staticData').then(response => {
         return callback(response)
      });
   },
   pharmacyOrderList: function (param, callback) {
      http.post(PHARMACY_URL + '/api/operation/order/list', param).then(response => {
         return callback(response)
      });
   },
   showOrderDetails: function (param, callback){
      http.post(PHARMACY_URL + '/api/operation/order/id', param).then(response => {
         return callback(response)
      });
   },
   pharmacyticketList: function (param, callback) {
      http.post(PHARMACY_URL + '/api/operation/pharm-tickets/list', param).then(response => {
         return callback(response)
      });
   },
   pharmacyticketEdit: function (param, callback) {
      http.post(PHARMACY_URL + '/api/operation/pharm-tickets/id', param).then(response => {
         return callback(response)
      });
   },
   rateReviewList: function (param, callback) {
      http.post(PHARMACY_URL + '/api/operation/ratings/list', param).then(response => {
         return callback(response)
      });
   },
   rateReviewDetail: function (param, callback) {
      http.post(PHARMACY_URL + '/api/operation/ratings/id', param).then(response => {
         return callback(response)
      });
   },
   getRatingInfo : function(param, callback){
      http.post(PHARMACY_URL + '/api/operation/ratings/store_id', param).then(response => {
         return callback(response)
      });
   },
   getReportList : function(param, callback){
      http.post(PHARMACY_URL + '/api/operation/reports/list', param).then(response => {
         return callback(response)
      });
   },
   pharmacyReportDetail : function(param, callback){
      http.post(PHARMACY_URL + '/api/operation/reports/stats', param).then(response =>{
          return callback(response)
      })
   },
   closePharmacyTicket : function(param,callback){
      http.post(PHARMACY_URL + '/api/operation/pharm-tickets/close', param).then(response => {
         return callback(response)
      });
   },
   appointmentCancel : function(param, callback){
      http.post(PHARMACY_URL + '/api/operation/order/cancel', param).then(response =>{
          return callback(response)
      })
   },

   dashboardv1: function (param, callback) {
    http.post(PHARMACY_URL + '/api/operation/dashboard/v1', param).then(response => {
       return callback(response)
    });
 },
 pharmacyList: function(callback) {
   http.get(PHARMACY_URL + '/api/operation/order/staticData').then(response => {
      return callback(response)
   });
},
pharmacyReport: function(param, callback){
   http.get(PHARMACY_URL + '/api/operation/reports/salesReport' + '?from=' + param.from + "&to=" + param.to + "&store_id=" + param.store_id).then(
      (response) => {
         return callback(response)
      }
   )
},
listAbandoned: function (param, callback) {
   http.post(PHARMACY_URL + '/api/operation/order/abandonedlist', param).then(response => {
      return callback(response)
   });
},
getAbandoned: function (param, callback) {
   http.post(PHARMACY_URL + '/api/operation/order/getAbandoned', param).then(response => {
      return callback(response)
   });
},
pharmacyCityList : function(callback){
   http.get(PHARMACY_URL + '/api/operation/order/staticData').then(response =>{
       return callback(response)
   })
},
   CityList : function(callback){
   http.get(PHARMACY_URL + '/api/operation/reports/cities').then(response =>{
       return callback(response)
   })
},
pharmacyAvailability : function(params,callback){
   http.post(PHARMACY_URL + '/api/operation/schedule/get',params).then(response =>{
       return callback(response)
   })
},
    subsList: function (params, callback) {
      http.post(FD_URL + '/subscription/list', params).then(response => {
         return callback(response)
      });
   },
   saveFamilyData: function (param, callback) {
      http.post(FD_URL + '/package/create', param).then(response => {
         return callback(response)
      });
   },
   familyHospital: function ( callback) {
      http.post(API_URL + '/doctor/familyHospital').then(response => {
         return callback(response)
      });
   },
   familySupport: function (param, callback) {
      http.post(API_URL + '/doctor/familySupport', param).then(response => {
         return callback(response)
      });
   },
   familyList: function (params, callback) {
      http.post(FD_URL + '/package/list',params).then(response => {
         return callback(response)
      });
   },
   
 subsDetails: function (params, callback) {
   http.post(FD_URL + '/subscription/details', params).then(response => {
      return callback(response)
   });
},
subsAppointments: function (params, callback) {
   http.post(FD_URL + '/subscription/userAppnts', params).then(response => {
      return callback(response)
   });
},
subsDoctorList: function (params, callback) {
   http.post(FD_URL + '/doctor/list', params).then(response => {
      return callback(response)
   });
},
changeDoctorSubs: function (params, callback) {
   http.post(FD_URL + '/subscription/changeDoctor', params).then(response => {
      return callback(response)
   });
},
   familyActive: function (params, callback) {
      http.post(FD_URL + '/package/changeStatus',params).then(response => {
         return callback(response)
      });
   },
   familyPackageId: function (params, callback) {
      http.get(FD_URL + '/package/' +params.package_id).then(response => {
         return callback(response)
      });
   },
   updateFamilyData: function (param, callback) {
      http.post(FD_URL + '/package/update', param).then(response => {
         return callback(response)
      });
   },
cancellationConfig:function(params,callback){
      http.post(API_URL + '/cms/addCancellationSettings', params).then(response => {
         return callback(response)
      });
   },
 cancellationConfigList:function(params,callback){
      http.post(API_URL + '/cms/listCancellationSettings', params).then(response => {
         return callback(response)
      });
   },
 editCancelConfig:function(params,callback){
      http.post(API_URL + '/cms/getCancellationSettings', params).then(response => {
         return callback(response)
      });
   },
 updateCancelConfig:function(params,callback){
      http.post(API_URL + '/cms/editCancellationSettings', params).then(response => {
         return callback(response)
      });
   },
   familySubscriptionList: function (param, callback) {
      http.post(FD_URL + '/subscription/subscribersList', param).then(response => {
         return callback(response)
      });
   },
   editSubscription: function (param, callback) {
      http.get(FD_URL + '/subscription/details/' +param.subscription_id).then(response => {
         return callback(response)
      });
   },
   addCaregiverPackage: function (params, callback) {
      http.post(CAREGIVER_URL + '/v1/admin/package/create', params).then(response => {
         return callback(response)
      })
   },
   getCaregiverPackageList: function (params, callback) {
      http.post(CAREGIVER_URL + '/v1/admin/package/list', params).then(response => {
         return callback(response)
      })
   },
   getCaregiverPackageData: function (params, callback) {
      http.post(CAREGIVER_URL + '/v1/admin/package/details', params).then(response => {
         return callback(response)
      })
   },
   editCaregiverPackageData: function (params, callback) {
      http.post(CAREGIVER_URL + '/v1/admin/package/edit', params).then(response => {
         return callback(response)
      })
   },
   getCaregiverAppointmentList: function (params, callback) {
      http.post(CAREGIVER_URL + '/v1/admin/lead/list', params).then(response => {
         return callback(response)
      })
   },
   getCaregiverLeadData: function (params, callback) {
      http.post(CAREGIVER_URL + '/v1/admin/lead/details', params).then(response => {
         return callback(response)
      })
   },
   updateLeadBookingData: function (params, callback) {
      http.post(CAREGIVER_URL + '/v1/admin/lead/update', params).then(response => {
         return callback(response)
      })
   },
   getCaregiverBookingStatusList: function (callback) {
      http.get(CAREGIVER_URL + '/v1/master/leadStatus').then(response => {
         return callback(response)
      })
   },
   getCaregiverProviderList: function (params, callback) {
      http.post(CAREGIVER_URL + '/v1/admin/providers', params).then(response => {
         return callback(response)
      })
   },
   getNotificationList: function (params, callback) {
      http.post(NOTIFICATION + '/v1/opt/notifications/onoff', params).then(response => {
         return callback(response)
      })
   },
   classificationList: function ( callback) {
      http.post(NOTIFICATION + '/v1/opt/notifications/userClassifications').then(response => {
         return callback(response)
      })
   },
   getReadNotifications: function ( callback) {
      http.post(NOTIFICATION + '/v1/opt/notifications/markAllAsRead').then(response => {
         return callback(response)
      })
   },
   getNotificationsGraph: function (params, callback) {
      http.post(NOTIFICATION + '/v1/opt/notifications/graph', params).then(response => {
         return callback(response)
      })
   },
   addCompanyDetails: function (param, callback) {
      http.post(PRE_EMPLOYEMENT + '/v1/admin/addCompany', param).then(response => {
         return callback(response)
      });
   },
   companyList: function (param, callback) {
      http.post(PRE_EMPLOYEMENT + '/v1/admin/listCompanies', param).then(response => {
         return callback(response)
      });
   },
   getMasterCompanies: function (callback) {
      http.get(PRE_EMPLOYEMENT + '/v1/admin/getCompanies').then(response => {
         return callback(response)
      });
   },
   getMasterPackages: function (callback) {
      http.post(API_URL + '/packages/master').then(response => {
         return callback(response)
      });
   },
   addPreEmployementService: function (param, callback) {
      http.post(PRE_EMPLOYEMENT + '/v1/admin/addService', param).then(response => {
         return callback(response)
      });
   },
   PreEmployementServiceList: function (param, callback) {
      http.post(PRE_EMPLOYEMENT + '/v1/admin/listServices', param).then(response => {
         return callback(response)
      });
   },
   getPreEmployementService: function (param, callback) {
      http.get(PRE_EMPLOYEMENT + '/v1/admin/service/' + param.srvc_id).then(response => {
         return callback(response)
      });
   },
   updatePreEmployementService: function (param, callback) {
      http.post(PRE_EMPLOYEMENT + '/v1/admin/updateService', param).then(response => {
         return callback(response)
      });
   },
   changePreEmployementServiceStatus: function (param, callback) {
      http.post(PRE_EMPLOYEMENT + '/v1/admin/changeStatus', param).then(response => {
         return callback(response)
      });
   },
   getInstrucitonsForPackages: function (param, callback) {
      http.post(API_URL + '/packages/getInstructionsforPackages', param).then(response => {
         return callback(response)
      });
   },
   companyEdit: function(param,callback){
      http.get(PRE_EMPLOYEMENT + '/v1/admin/' + param.cmp_id).then(response =>{
          return callback(response)
      })
   },
   companyEmployee: function(param,callback){
      http.post(PRE_EMPLOYEMENT + '/v1/admin/employeeList', param).then(response =>{
          return callback(response)
      })
   },
   companyAssigned: function(param,callback){
      http.post(PRE_EMPLOYEMENT + '/v1/admin/getassignedservices', param).then(response =>{
          return callback(response)
      })
   },
   companyUpdate: function(param,callback){
      http.post(PRE_EMPLOYEMENT + '/v1/admin/updateCompany', param).then(response =>{
          return callback(response)
      })
   },
   updateCompanyStatus: function(param,callback){
      http.post(PRE_EMPLOYEMENT + '/v1/admin/changeCompanyStatus', param).then(response =>{
          return callback(response)
      })
   },
    getEmployeeProducts : function(params, callback){
      http.post(API_URL + '/hospital/products', params).then(response => {
         return callback(response)
      })
   }, 
   waseelApprovalSubmission : function(params, callback){
      http.post(WASEEL_URL + '/v1/approvalSubmission', params).then(response => {
         return callback(response)
      })
   },
   waseelPharmacies : function(callback){
      http.get(WASEEL_URL + '/v1/getWaseelPharmacies').then(response => {
         return callback(response)
      })
   },
   waseelMedicines: function(params,callback){
      http.post(WASEEL_URL + '/v1/getMedicines',params).then(response => {
         return callback(response)
      })
   },
   getWaseelEvents : function(params, callback){
      http.post(WASEEL_URL + '/v1/fetchWaseelEvents', params).then(response => {
         return callback(response)
      })
   },
   getDoctorSchedules : function(params, callback){
      http.post(API_URL + '/schedule/get-emp-session', params).then(response => {
         return callback(response)
      })
   },    
   blockDoctorSchedules : function(params, callback){
      http.post(API_URL + '/schedule/add-black-sch', params).then(response => {
         return callback(response)
      })
   }, 
   unBlockDoctorSchedules : function(params, callback){
      http.post(API_URL + '/schedule/unblock-black-sch', params).then(response => {
         return callback(response)
      })
   },
   getCustomizeSchedules : function(params, callback){
      http.post(API_URL + '/schedule/get-custom-date', params).then(response => {
         return callback(response)
      })
   }, 
   saveCustomizeSchedules : function(params, callback){
      http.post(API_URL + '/schedule/add-calndrsch', params).then(response => {
         return callback(response)
      })
   },
   saveSchedulesData: function (requestData, callback) {
      http.post(API_URL + '/schedule/add/doc', requestData).then(response => {
         return callback(response)
      })
   } ,
   getBlockedSchedules : function(params, callback){
      http.post(API_URL + '/schedule/build-calndr', params).then(response => {
         return callback(response)
      })
   },
   saveLabNurseSchedules: function (requestData, callback) {
      http.post(API_URL + '/schedule/add/emp', requestData).then(response => {
         return callback(response)
      })
   },
   getVitaminIvServices: function (requestData, callback) {
      http.post(PH_URL+'/v6/generic/questionnaires', requestData).then(response => {
         return callback(response)
      })
   },  
   addIvQuestionnaires: function (requestData, callback) {
      http.post(API_URL +'/patients/addQuestionnaires', requestData).then(response => {
         return callback(response)
      })
   },
   getdata:function(requestData,callback){
      http.post(STATIC_URL + '/general/getStaticData', requestData).then(response => {
         return callback(response)
      })
      
   },
   createWellnessServices: function(requestData, callback) {
      http.post(CORPORATE_URL + '/opt/package/add', requestData).then(response => {
         return callback(response)
      })
   }, 
   fetchWellnessServiceName: function(requestData, callback) {
      http.post(CORPORATE_URL + '/opt/package/list', requestData).then(response => {
         return callback(response)
      })
   }, 
   fetchWellnessBookingList: function(requestData, callback) {
      http.post(CORPORATE_URL + '/opt/booking/list', requestData).then(response => {
         return callback(response)
      })
   },
   fetchWellnessBookingDetails: function(requestData, callback) {
      http.post(CORPORATE_URL + '/opt/booking/details', requestData).then(response => {
         return callback(response)
      })
   },
   WellnessBookingStatus: function(requestData, callback) {
      http.post(CORPORATE_URL + '/opt/status/update', requestData).then(response => {
         return callback(response)
      })
   },
   updateCorporateWellnessService: function(requestData, callback) {
      http.post(CORPORATE_URL + '/opt/package/updatestatus', requestData).then(response => {
         return callback(response)
      })
   },
   fetchWellnessPackageIds: function(requestData, callback) {
      http.post(CORPORATE_URL + '/opt/package/id', requestData).then(response => {
         return callback(response)
      })
   },
   updatePackages: function(requestData, callback) {
      http.post(CORPORATE_URL + '/opt/package/update', requestData).then(response => {
         return callback(response)
      })
   },
   adddonation:function(requestData,callback){
      http.post(BLOOD_DONATION_URL + 'opt/package/add', requestData).then(response => {
         return callback(response)
      })

   } ,
   donationList:function(requestData,callback){
      http.post(BLOOD_DONATION_URL + 'opt/package/list', requestData).then(response => {
         return callback(response)
      })

   } ,
   donationById:function(requestData,callback){
      http.post(BLOOD_DONATION_URL + 'opt/package/details', requestData).then(response => {
         return callback(response)
      })

   } ,
   updateDonation:function(requestData,callback){
      http.post(BLOOD_DONATION_URL + 'opt/package/update', requestData).then(response => {
         return callback(response)
      })

   },

   fetchDonationSubscribers:function(requestData,callback){
      http.post(BLOOD_DONATION_URL + 'opt/subscription/list', requestData).then(response => {
         return callback(response)
      })
   },

   SubscriptionDetails: function (param, callback) {
      http.post(BLOOD_DONATION_URL + 'opt/subscription/details', param).then(response => {
         return callback(response)
      });
   },
   addPhysioSession:function(requestData,callback){
      http.post(PHYSIO_SESSION_URL + 'admin/session/add', requestData).then(response => {
         return callback(response)
      })

   } ,
   physioSessionList:function(requestData,callback){
      http.post(PHYSIO_SESSION_URL + 'admin/session/list', requestData).then(response => {
         return callback(response)
      })

   } ,
   physioSessionStatus:function(requestData,callback){
      http.post(PHYSIO_SESSION_URL + 'admin/session/updateStatus', requestData).then(response => {
         return callback(response)
      })

   } ,
   sessionById:function(requestData,callback){
      http.post(PHYSIO_SESSION_URL + 'admin/session/details', requestData).then(response => {
         return callback(response)
      })
   } ,
   updatePhysioSession:function(requestData,callback){
      http.post(PHYSIO_SESSION_URL + 'admin/session/update', requestData).then(response => {
         return callback(response)
      })

   } ,
   physioEmployeeList:function(callback){
      http.get(API_URL + '/general/getPhysioList').then(response => {
         return callback(response)
      })

   } , 
   physioSubscribeList:function(requestData, callback){
      http.post(PHYSIO_SESSION_URL +'admin/physio/list', requestData).then(response => {
         return callback(response)
      })
   } ,
   fetchNurseSubscribers:function(requestData,callback){
      http.post(NURSE_SUBSCRIPTION_URL + 'opt/subscription/list', requestData).then(response => {
         return callback(response)
      })
   },
   nurseSubscriptionDetails: function (requestData, callback) {
      http.post(NURSE_SUBSCRIPTION_URL + 'opt/subscription/details', requestData).then(response => {
         return callback(response)
      });
   },
   physioSubscriptionDetails: function (requestData, callback) {
      http.post(PHYSIO_SESSION_URL + 'admin/physio/details', requestData).then(response => {
         return callback(response)
      });
   },
  addCreditInvoice:function(requestData,callback){
      http.post(API_URL + '/creditUserInvoice/add', requestData).then(response => {
         return callback(response)
      })

   }, 
   creditInvoiceList:function(requestData,callback){
      http.post(API_URL + '/creditUserInvoice/list', requestData).then(response => {
         return callback(response)
      })

   },
   creditUserDetails:function(requestData,callback){
      http.post(API_URL + '/dashboardV3/getCreditUserDetails', requestData).then(response => {
         return callback(response)
      })

   }, 
   creditUsers:function(callback){
      http.get(API_URL + '/dashboardV3/getCreditUsers').then(response => {
         return callback(response)
      })

   },
   updatePractitionerStatus:function(requestData,callback){
   http.post(API_URL + '/cms/edit', requestData).then(response => {
      return callback(response)
      })
   },
   removeDoctor:function(requestData,callback){
      http.post(API_URL + '/doctor/delete', requestData).then(response => {
         return callback(response)
         })
   },
   saveInHouseReq (params, callback) {
      http.post(PH_URL + '/v5/manual/inhousePrebook', params).then(response => {
         return callback(response)
      })
   },
   applyPriceChanges (params, callback) {
      http.post(PH_URL + '/v5/manual/editInsurancePrec', params).then(response => {
         return callback(response)
      })
   },
   getDocLists : function (params, callback) {
      http.post(API_URL + '/general/doctorList', params).then(response => {
         return callback(response)
      })
   },
   getDrugList : function (params, callback) {
      http.post(STATIC_URL + '/general/drugsListV2', params).then(response => {
         return callback(response)
      })
   },
   creditInvoiceDownload: function(requestUrl, callback){
      http.get(requestUrl).then(response => {
         return callback(response)
      } )
   },
   checkInsDetails: function (params, callback) {
      http.post(PH_URL + '/v5/waseel/checkBupaMembership', params).then(response => {
         return callback(response)
      })
   },
   updateDaignosisStatus: function(param,callback){
      http.post(API_URL + '/appointments/updateEditDiagnosis', param).then(response =>{
          return callback(response)
      })
   },
   referalList: function(param,callback){
      http.post(API_URL + '/referrals/referral_list', param).then(response =>{
          return callback(response)
      })
   },
   referalDetails: function(param,callback){
      http.post(API_URL + '/referrals/referral_details', param).then(response =>{
          return callback(response)
      })
   },
   referalUpdate: function(param,callback){
      http.post(API_URL + '/referrals/referral_update', param).then(response =>{
          return callback(response)
      })
   },
   referalCancel: function(param,callback){
      http.post(API_URL + '/referrals/cancel', param).then(response =>{
          return callback(response)
      })
   },
   referralDashboard: function (param, callback) {
      http.post(API_URL + '/referrals/referral_dashboardNew', param).then(response => {
         return callback(response)
      })
   },
   referralAuthRequese: function(params, callback) {
      http.post(PH_URL + '/v6/referral/referralAuthRequese', params).then(response =>{
          return callback(response)
      })
   },
   preAuthApprovalStatus: function(params, callback) {
      http.post(PH_URL + '/v6/referral/preAuthApprovalStatus', params).then(response =>{
          return callback(response)
      })
   },
   preAuthReferralList: function(params, callback) {
      http.post(PH_URL + '/v6/referral/preAuthReferralList', params).then(response =>{
          return callback(response)
      })
   },
   cancelPreAuthReferralReq: function(params, callback) {
      http.post(PH_URL + '/v6/referral/cancelPreAuthReferralReq', params).then(response =>{
          return callback(response)
      })
   },
   referalLocation: function (param, callback) {
      http.post(APPOINTMENT_SERVICE_URL + 'app/sendSMS', param).then(response => {
         return callback(response)
      })
   },
   eligibilityResp: function(params, callback) {
      http.post(PH_URL + '/v5/waseel/eligibilityResp', params).then(response =>{
         return callback(response)
     })
   },
   diagnosisHistory: function(param,callback){
      http.post(API_URL + '/appointments/diagnosisHistory', param).then(response =>{
          return callback(response)
      })
   },
   prescriptionApproval :function(param,callback){
      http.post(API_URL + '/appointments/prescriptionApproval', param).then(response =>{
          return callback(response)
      })
   },
   activeEmpList: function (param,callback) {
      http.post(CAPTAIN_URL + 'v1/active-emp',param).then(response => {
         return callback(response)
      })
   },
   providerChatMsg: function(param, callback){
      http.post(SOCKET_URL + "/admin-chat/send-message", param).then(response => {
         return callback(response)
      })  
   },
   chatHistory: function(param, callback){
      http.post(SOCKET_URL + "/admin-chat/get-message", param).then(response => {
         return callback(response)
      }) 
   },
   downloadReport: function(param, callback){
      http.post(USER_SERVICES_URL + "v1/patient/allreports", param).then(response => {
         return callback(response)
      }) 
   },
   serviceList:function(callback){
      http.get(CAPTAIN_URL + 'v1/usr').then(response => {
         console.log(response,'user respone');
         return callback(response)
      })
   },
   rateAndReview: function(param, callback){
      http.post(API_URL + "/dashboardV3/ratingAndReview", param).then(response => {
         return callback(response)
      }) 
   },
   ratingReviewList: function(param, callback){
      http.post(API_URL + "/dashboardV3/ratingList", param).then(response => {
         return callback(response)
      }) 
   },
   rateAndReviewList: function(param, callback){
      http.post(API_URL + "/dashboardV3/ratingAndReviewList", param).then(response => {
         return callback(response)
      }) 
   },
   updateRateAndReview: function(param, callback){
      http.post(API_URL + "/dashboardV3/ratingAndReviewUpdate", param).then(response => {
         return callback(response)
      }) 
   },
   shiftSummaryList: function(param, callback){
      http.post(API_URL + "/shiftsummary/list",param).then(response => {
         return callback(response)
      }) 
   },
   shiftSummaryFilter: function(param, callback){
      http.post(API_URL + "/shiftsummary/filter",param).then(response => {
         return callback(response)
      }) 
   },
   shiftSummaryEdit: function(param, callback){
      http.post(API_URL + "/shiftsummary/edit",param).then(response => {
         return callback(response)
      }) 
   },
   shiftSummaryAdd: function(param, callback){
      http.post(API_URL + "/shiftsummary/add",param).then(response => {
         return callback(response)
      }) 
   },
   shiftSummaryCategory: function(callback){
      http.get(API_URL + "/shiftsummary/categories").then(response => {
         return callback(response)
      }) 
   },
   shiftHistoryList: function(param, callback){
      http.post(API_URL + "/shiftsummary/list",param).then(response => {
         return callback(response)
      }) 
   },
   shiftDeleteSummary: function(param, callback){
      http.post(API_URL + "/shiftsummary/delete",param).then(response => {
         return callback(response)
      })
   },
   serviceList:function(callback){
      http.get(CAPTAIN_URL + 'v1/usr').then(response => {
         return callback(response)
      })
   },
   downloadSummary:function(param,callback){
      http.get(API_URL + param).then(response => {
         return callback(response)
      })
   },
   doctorList: function(callback){
      http.post(API_URL + "/dashboardV3/getDoctorList").then(response => {
         return callback(response)
      })
   },
   getServiceDepartment: function(param,callback){
      http.post(API_URL + "/general/subSpecialistDept",param).then(response => {
         return callback(response)
      })
   },
   ratedList:function(param, callback){
      http.post(API_URL + "/dashboardV3/topRated", param).then(response => {
         return callback(response)
      })
   },
   labConfigList: function (param, callback) {
      http.post(API_URL + "/labPriceConfig/list", param).then(response => {
         return callback(response)
      })
   },
   labConfigAdd: function (param, callback) {
      http.post(API_URL + "/labPriceConfig/add", param).then(response => {
         return callback(response)
      }) 
   },
   labConfigEdit: function (param, callback) {
      http.post(API_URL + "/labPriceConfig/edit", param).then(response => {
         return callback(response)
      })
   },
   labConfigId: function (param, callback) {
      http.post(API_URL + "/labPriceConfig/id", param).then(response => {
         return callback(response)
      })
   },
   changeLabStatus: function (param, callback) {
      http.post(API_URL + "/labPriceConfig/updateStatus", param).then(response => {
         return callback(response)
      })
   },
   getLabDetails: function (callback) {
      http.get(STATIC_URL + '/general/getLabDetails').then(response => {
         return callback(response)
      })
   },
   getDispensesList: function (param, callback) {
      http.post(AL_DAWA_URL + 'dispenses/list', param).then(response => {
         return callback(response)
      })
   },
   getDispensesId: function (param, callback) {
      http.post(AL_DAWA_URL + 'dispenses/id', param).then(response => {
         return callback(response)
      })
   },
   getOrderDetails: function (param, callback) {
      http.post(AL_DAWA_URL + 'order/details', param).then(response => {
         return callback(response)
      })
   },
   getCategories: function (callback) {
      http.post(API_URL + '/general/getCategory').then(response => {
         return callback(response)
      });
   },
   getServiceName: function (param, callback) {
      http.post(API_URL + '/general/serviceName',param).then(response => {
         return callback(response)
      })
   },
   multiSessionSubscribeList:function(requestData, callback){
      http.post(TELE_MEDICINE_URL +'admin/multisessions/list', requestData).then(response => {
         return callback(response)
      })
   } ,
   multiSessionSubscribeDetails:function(requestData, callback){
      http.post(TELE_MEDICINE_URL +'admin/multisessions/details', requestData).then(response => {
         return callback(response)
      })
   } ,
   getKidsVaccineAppointmentList: function (param, callback) {
      http.post(API_URL + '/kidsVaccinationRequets/list', param).then(response => {
         return callback(response)
      });
   },
   getKidsVaccineDetails: function (param, callback) {
      http.post(API_URL + '/kidsVaccinationRequets/id', param).then(response => {
         return callback(response)
      });
   },
   multiSessionAbandonedList:function(requestData, callback){
      http.post(TELE_MEDICINE_URL +'admin/multisessions/abadoned/list', requestData).then(response => {
         return callback(response)
      })
   } ,
   multiSessionAbandonedDetails:function(requestData, callback){
      http.post(TELE_MEDICINE_URL +'admin/multisessions/abadoned/details', requestData).then(response => {
         return callback(response)
      })
   } ,
   editKidsVaccineDetails: function (param, callback) {
      http.post(API_URL + '/kidsVaccinationRequets/edit', param).then(response => {
         return callback(response)
      });
   },
   cancelMultiSessionSubscription: function (param, callback) {
      http.post(API_URL + '/subscriptions/cancelSubscription', param).then(response => {
         return callback(response)
      })
   },
   getdrop: function (callback) {
      http.post(API_URL + '/general/getDoctorCategory').then(response => {
         return callback(response)
      })
   },
   insuranceUnlink: function (param, callback) {
      http.post(API_URL + '/patients/unlinkInsurance', param).then(response => {
         return callback(response)
      });
   },
   updateUserInfo: function (param, callback) {
      http.post(API_URL + "/patients/updateUserInfo", param).then(response => {
         return callback(response)
      })
   },
   addCancelSessionConfig: function (param, callback) {
      http.post(API_URL + "/cms/addCancelSessionConfig", param).then(response => {
         return callback(response)
      })
   },
   listCancelSessionConfig: function (param, callback) {
      http.post(API_URL + "/cms/listCancelSessionConfig", param).then(response => {
         return callback(response)
      })
   },
   getCancelSessionConfig:function(params,callback){
      http.post(API_URL + '/cms/getCancelSessionConfig', params).then(response => {
         return callback(response)
      });
   },
   updateCancelSessionConfig:function(params,callback){
      http.post(API_URL + '/cms/updateCancelSessionConfig', params).then(response => {
         return callback(response)
      });
   },
   deleteReason: function (requestData, callback) {
      http.post(API_URL + '/cms/removeReason', requestData).then(response => {
         return callback(response)
      })
   },
   getproviders: function (callback) {
      http.post(API_URL + '/general/getProviders').then(response => {
         return callback(response)
      })
   },
   getCancelReasons: function (requestData,callback) {
      http.post(API_URL + '/general/getReasons', requestData).then(response => {
         return callback(response)
      })
   },
   getNationalityData: function (callback) {
      http.get(PH_URL + '/v5/generic/staticData').then(response => {
         return callback(response)
      })
   },
   manualRegister: function (param, callback) {
      http.post(AUTH_URL + '/manual/register', param).then(response => {
         return callback(response)
      })
   },
   getSymptoms: function (callback) {
      http.get(API_URL + '/general/getSymptoms').then(response => {
         return callback(response)
      })
   },
   suspensionLogs: function (param, callback) {
      http.post(API_URL + '/patients/suspensonLogs', param).then(response => {
         return callback(response)
      })
   },
   getTubeTypes: function (callback) {
      http.get(API_URL + '/general/getTubeTypes').then(response => {
         return callback(response)
      })
   },
   getEClinics: function (callback) {
      http.get(API_URL + '/general/getEclinics').then(response => {
         return callback(response)
      })
   },
   getPrescriptionList: function (param,callback) {
      http.post(API_URL + '/prescription/list',param).then(response => {
         return callback(response)
      })
   },
   getPrescriptionDetails: function (param,callback) {
      http.post(API_URL + '/prescription/details',param).then(response => {
         return callback(response)
      })
   },
   getPrescStaticData: function (callback) {
      http.get(API_URL + '/prescription/staticData').then(response => {
         return callback(response)
      })
   },
  manualBooking : function (requestData, callback) {
     http.post(PH_URL + '/v5/manual/subsLabBrowse', requestData).then(response => {
         return callback(response)
      })
   },
   sessionBooking: function (requestData, callback) {
      http.post(NURSE_SUBSCRIPTION_URL + 'app/bookSessions', requestData).then(response => {
         return callback(response)
      })
   },
   manualAddPatient: function (param, callback) {
      http.post(AUTH_URL + '/manual/addPatient', param).then(response => {
         return callback(response)
      })
   },
   getAllPackageName: function (param, callback) {
      http.post(API_URL + '/general/allPackages', param).then(response => {
         return callback(response)
      })
   },
   updateInsuranceStatus:function (param,callback){
      http.post(API_URL + '/services/updatestatus', param).then(response => {
         return callback(response)
      })
   },
   getLabSlots: function (param, callback) {
      http.post(PH_URL + '/v6/referral/browse ', param).then(response => {
         return callback(response)
      })
   },
   getNurseSlots: function (param, callback) {
      http.post(NURSE_SUBSCRIPTION_URL + 'app/referralBrowse ', param).then(response => {
         return callback(response)
      })
   },
   getPhysioSlots: function (param, callback) {
      http.post(PHYSIO_SESSION_URL + 'app/referralBrowse ', param).then(response => {
         return callback(response)
      })
   },
   getHomeVisitSlots: function (param, callback) {
      http.post(HOME_VIST_DOCTOR_URL + 'app/referralBrowse ', param).then(response => {
         return callback(response)
      })
   },
   sendOTP: function (param, callback) {
      http.post(AUTH_URL + '/manual/registerUser', param).then(response => {
         return callback(response)
      })
   },
   editHomeVisitLocation: function (param, callback) {
      http.post(API_URL + '/general/editLocation', param).then(response => {
         return callback(response)
      })
   },
   addNewLocation: function (param, callback) {
      http.post(API_URL + '/general/addLocation', param).then(response => {
         return callback(response)
      })
   },
   updateShowInApp:function (param,callback){
      http.post(API_URL + '/services/showInApp', param).then(response => {
      return callback(response)
      })
   },
   sessionList:function(requestData, callback){
      http.post(API_URL +'/session/sessionlist', requestData).then(response => {
         return callback(response)
      })
   } ,
   sessionDetails:function(requestData, callback){
      http.post(API_URL +'/session/sessiondetails', requestData).then(response => {
         return callback(response)
      })
   } ,
   sessionCancel: function (requestData, callback) {
      http.post(NURSE_SUBSCRIPTION_URL + 'app/cancelSession', requestData).then(response => {
         return callback(response)
      })
   },
   sessionReports: function (requestData, callback) {
      http.post(API_URL + '/session/reportsHistory', requestData).then(response => {
         return callback(response)
      })
   },
   rescheduleSession: function (requestData, callback) {
      http.post(NURSE_SUBSCRIPTION_URL + 'app/rescheduleSession', requestData).then(response => {
         return callback(response)
      })
   },
   appointmentComplte: function (requestData, callback) {
      http.post(NURSE_SUBSCRIPTION_URL + 'app/appointmentComplete', requestData).then(response => {
         return callback(response)
      })
   },
   cancelMultiSession: function (param, callback) {
      http.post(API_URL + '/session/cancelFullSessions', param).then(response => {
         return callback(response)
      })
   },
   updateRefferalOnly:function (param,callback){
      http.post(API_URL + '/services/refferalOnly', param).then(response => {
      return callback(response)
      })
   },
   updateInsServices:function (param,callback){
      http.post(API_URL + '/services/updateInsuranceService', param).then(response => {
      return callback(response)
      })
   },
   announcementList:function (param,callback){
      http.post(API_URL + '/announcement/list',param).then(response => {
      return callback(response)
      })
   },
   addAnnouncement:function (param,callback){
      http.post(API_URL + '/announcement/add',param).then(response => {
      return callback(response)
      })
   },
   announcementDetails:function (param,callback){
      http.post(API_URL + '/announcement/id',param).then(response => {
      return callback(response)
      })
   },
   announcementUpdate:function (param,callback){
      http.post(API_URL + '/announcement/edit',param).then(response => {
      return callback(response)
      })
   },
   announcementStatusUpdate:function (param,callback){
      http.post(API_URL + '/announcement/updateStatus',param).then(response => {
      return callback(response)
      })
   },
   deleteAnnouncement:function (param,callback){
      http.post(API_URL + '/announcement/delete',param).then(response => {
      return callback(response)
      })
   },
   removeAccList : function(param,callback) {
      http.post(API_URL + '/cms/deleteReason', param).then(response => {
      return callback(response)
      })
   },

   saveDeleteAccReason : function(param,callback) {
      http.post(API_URL + '/cms/saveReason', param).then(respons =>{
        return callback(respons)
      })
   },
   getDeleteAcctReasonList: function (param, callback) {
      http.post(API_URL + '/cms/getAllReason',param).then(respons => {
         return callback(respons)
      })
   },

   editAccutDetails: function (params, callback) {
      http.post(API_URL + '/cms/editReason', params).then(response => {
         return callback(response)
      })
   },
   getAccutDetails: function (params, callback) {
      http.post(API_URL + '/cms/getById', params).then(response => {
         return callback(response)
      })
   },
   getChronicsList: function (params, callback) {
      http.post(API_URL + '/cms/getChronicsList', params).then(response => {
         return callback(response)
      })
   },
   saveChronics: function (params, callback) {
      http.post(API_URL + '/cms/saveChronics', params).then(response => {
         return callback(response)
      })
   },
   getChronicsById: function (params, callback) {
      http.post(API_URL + '/cms/getChronics', params).then(response => {
         return callback(response)
      })
   },
   editChronics: function (params, callback) {
      http.post(API_URL + '/cms/updateChronics', params).then(response => {
         return callback(response)
      })
   },
   chronicsStatus: function (params, callback) {
      http.post(API_URL + '/cms/statusUpdate', params).then(response => {
         return callback(response)
      })
   },
   getChronicTypeList: function (params, callback) {
      http.post(API_URL + '/cms/getChronicTypeList', params).then(response => {
         return callback(response)
      })
   },
   chronicTypeStatus: function (params, callback) {
      http.post(API_URL + '/cms/updateChronicTypeStatus', params).then(response => {
         return callback(response)
      })
   },
   saveChronicType: function (params, callback) {
      http.post(API_URL + '/cms/saveChronicType', params).then(response => {
         return callback(response)
      })
   },
   getChronicTypeById: function (params, callback) {
      http.post(API_URL + '/cms/getChronicType', params).then(response => {
         return callback(response)
      })
   },
   getChronicsDiseases: function (callback) {
      http.get(API_URL + '/general/getChronicsDiseases').then(response => {
         return callback(response)
      })
   },
   editChronicType: function (params, callback) {
      http.post(API_URL + '/cms/updateChronicType', params).then(response => {
         return callback(response)
      })
   },
   getMedicineInstructionsList: function (params, callback) {
      http.post(API_URL + '/cms/listInstructions', params).then(response => {
         return callback(response)
      })
   },
   instructionStatus: function (params, callback) {
      http.post(API_URL + '/cms/StatusupdateInstruction', params).then(response => {
         return callback(response)
      })
   },
   saveInstruction: function (params, callback) {
      http.post(API_URL + '/cms/addInstruction', params).then(response => {
         return callback(response)
      })
   },
   getInstructionId: function (params, callback) {
      http.post(API_URL + '/cms/getInstructionById', params).then(response => {
         return callback(response)
      })
   },
   editInstruction: function (params, callback) {
      http.post(API_URL + '/cms/editInstruction', params).then(response => {
         return callback(response)
      })
   },
   getCDMDoctorsList: function (params, callback) {
      http.post(API_URL + '/cms/getCDMDoctorsList', params).then(response => {
         return callback(response)
      })
   },
   updateStatusCDM: function (params, callback) {
      http.post(API_URL + '/cms/updateStatusCDM', params).then(response => {
         return callback(response)
      })
   },
   getMedicationDayList: function (params, callback) {
      http.post(API_URL + '/cms/listMedicnDays', params).then(response => {
         return callback(response)
      })
   },
   saveMedicationDay: function (params, callback) {
      http.post(API_URL + '/cms/addMedicnDays', params).then(response => {
         return callback(response)
      })
   },
   editMedicationDay: function (params, callback) {
      http.post(API_URL + '/cms/editMedicnDays', params).then(response => {
         return callback(response)
      })
   },
   getMedicationDayById: function (params, callback) {
      http.post(API_URL + '/cms/getMedicnDayById', params).then(response => {
         return callback(response)
      })
   },
   UpdateDaysStatus: function (params, callback) {
      http.post(API_URL + '/cms/UpdateDaysStatus', params).then(response => {
         return callback(response)
      })
   },
   getMedicationIntervalList: function (params, callback) {
      http.post(API_URL + '/cms/intervalslist', params).then(response => {
         return callback(response)
      })
   },
   saveMedicationInterval: function (params, callback) {
      http.post(API_URL + '/cms/addIntervals', params).then(response => {
         return callback(response)
      })
   },
   editMedicationInterval: function (params, callback) {
      http.post(API_URL + '/cms/editInterval', params).then(response => {
         return callback(response)
      })
   },
   getMedicationIntervalById: function (params, callback) {
      http.post(API_URL + '/cms/getIntervalById', params).then(response => {
         return callback(response)
      })
   },
   UpdateIntervalStatus: function (params, callback) {
      http.post(API_URL + '/cms/UpdateIntervalStatus', params).then(response => {
         return callback(response)
      })
   },
     getIvBenefits: function (callback) {
      http.get(API_URL + '/general/getIvBenefits').then(response => {
         return callback(response)
      })
   },
     getIvCatgrys: function (callback) {
      http.get(API_URL + '/general/getIvCategories').then(response => {
         return callback(response)
      })
   },
     getIvDrips: function (callback) {
      http.get(API_URL + '/general/getIvDrips').then(response => {
         return callback(response)
      })
   },
     getIvFrqncys: function (callback) {
      http.get(API_URL + '/general/getIvFrequency').then(response => {
         return callback(response)
      })
   },
     getIvIngrdnts: function (callback) {
      http.get(API_URL + '/general/getIvIngredients').then(response => {
         return callback(response)
      })
   },
   addMasterIvDrip: function (params, callback) {
      console.log(params,'Params');
      http.post(CMS_URL + 'ivDrip/add', params).then(response => {
         return callback(response)
      })
   },
   updateMasterIvDrip: function (params, callback) {
      console.log(params,'Params-update');
      http.post(CMS_URL + 'ivDrip/update', params).then(response => {
         return callback(response)
      })
   },
    MasterIvDripStatus: function (params, callback) {
      console.log(params,'Params-update');
      http.post(CMS_URL + 'ivDrip/updateStatus', params).then(response => {
         return callback(response)
      })
   },
    getMasterIvDrip: function (params, callback) {
      console.log(params,'get details');
      http.post(CMS_URL + 'ivDrip/get', params).then(response => {
         return callback(response)
      })
   },
   getIvDripList: function (params, callback) {
      http.get(CMS_URL + 'ivDrip/list'+`?page=${params.page}&limit=${params.limit}`).then(response => {
         return callback(response)
      })
   },
   addMasterIngredients: function (params, callback) {
      http.post(CMS_URL + 'ivIngredients/add', params).then(response => {
         return callback(response)
      })
   },
   updateMasterIngredients: function (params, callback) {
      http.post(CMS_URL + 'ivIngredients/update', params).then(response => {
         return callback(response)
      })
   },
    updateStatusIngredients: function (params, callback) {
      http.post(CMS_URL + 'ivIngredients/updateStatus', params).then(response => {
         return callback(response)
      })
   },
    getMasterIngredients: function (params, callback) {
      http.post(CMS_URL + 'ivIngredients/get', params).then(response => {
         return callback(response)
      })
   },
   getIngredientsList: function (params, callback) {
      http.get(CMS_URL + 'ivIngredients/list'+`?page=${params.page}&limit=${params.limit}`).then(response => {
         return callback(response)
      })
   },
    addMasterCategory: function (params, callback) {
      http.post(CMS_URL + 'category/add', params).then(response => {
         return callback(response)
      })
   },
   updateMasterCategory: function (params, callback) {
      http.post(CMS_URL + 'category/update', params).then(response => {
         return callback(response)
      })
   },
    updateStatusCategory: function (params, callback) {
      http.post(CMS_URL + 'category/updateStatus', params).then(response => {
         return callback(response)
      })
   },
    getMasterCategory: function (params, callback) {
      http.post(CMS_URL + 'category/get', params).then(response => {
         return callback(response)
      })
   },
   getCategoryList: function (params, callback) {
      http.get(CMS_URL + 'Category/list'+`?page=${params.page}&limit=${params.limit}`).then(response => {
         return callback(response)
      })
   },
   addMasterFrequency: function (params, callback) {
      http.post(CMS_URL + 'frequency/add', params).then(response => {
         return callback(response)
      })
   },
   updateMasterFrequency: function (params, callback) {
      http.post(CMS_URL + 'frequency/update', params).then(response => {
         return callback(response)
      })
   },
    updateStatusFrequency: function (params, callback) {
      http.post(CMS_URL + 'frequency/updateStatus', params).then(response => {
         return callback(response)
      })
   },
    getMasterFrequency: function (params, callback) {
      http.post(CMS_URL + 'frequency/get', params).then(response => {
         return callback(response)
      })
   },
   getFrequencyList: function (params, callback) {
      http.get(CMS_URL + 'frequency/list'+`?page=${params.page}&limit=${params.limit}`).then(response => {
         return callback(response)
      })
   },
   addMasterBenefits: function (params, callback) {
      http.post(CMS_URL + 'benefits/add', params).then(response => {
         return callback(response)
      })
   },
   updateMasterBenefits: function (params, callback) {
      http.post(CMS_URL + 'benefits/update', params).then(response => {
         return callback(response)
      })
   },
    updateStatusBenefits: function (params, callback) {
      http.post(CMS_URL + 'benefits/updateStatus', params).then(response => {
         return callback(response)
      })
   },
    getMasterBenefits: function (params, callback) {
      http.post(CMS_URL + 'benefits/get', params).then(response => {
         return callback(response)
      })
   },
   getBenefitsList: function (params, callback) {
      http.get(CMS_URL + 'benefits/list'+`?page=${params.page}&limit=${params.limit}`).then(response => {
         return callback(response)
      })
   },
   getTestMasters: function (param,callback) {
      http.get(API_URL + '/general/getMasterTest' + `?pvdr_name=${param.prvd_cd}`).then(response => {
         return callback(response)
      })
   },
   nusreReferral: function(param,callback){
      http.post(API_URL + '/referrals/referral_service', param).then(response =>{
          return callback(response)
      })
   },
   getCdmApptList: function (params,callback) {
      http.post(API_URL + '/cdmappointments/list',params).then(response => {
         return callback(response)
      })
   },
   getCdmApptDetails: function (params,callback) {
      http.post(API_URL + '/cdmappointments/id',params).then(response => {
         return callback(response)
      })
   },
   getPrescriptionData: function (params,callback) {
      http.post(API_URL + '/cdmappointments/getPrescription',params).then(response => {
         return callback(response)
      })
   },
   getDoctorApnts: function (params,callback) {
      http.post(API_URL + '/doctor/activity',params).then(response => {
         return callback(response)
      })
   },
   getIbanVerified: function (params, callback) {
      http.post(ADMIN_SERVICE_URL + '/singleView/ibanVerification', params).then(response => {
         return callback(response)
      })
   }
}
export default API


// WEBPACK FOOTER //
// ./src/services/api.js